import classNames from 'classnames';
import css from './modal.module.scss';

interface Props {
  quantity: number;
  onClick: (index: number) => void;
  getClassName: (index: number) => string;
}

function QuizPageIndicator({ quantity, onClick, getClassName }: Readonly<Props>) {
  return (
    <div className={css.questions_index}>
      {[...Array(quantity)].map((_, index) => {
        return (
          <button
            key={`round-${index}`} /* NOSONAR */
            onClick={() => onClick(index)}
            className={classNames(css.round, getClassName(index))}>
            {index + 1}
          </button>
        );
      })}
    </div>
  );
}

export default QuizPageIndicator;
